class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Gate 3D, CEP calculator no drawer */
(function () {
  function onlyDigits(v) {
    return String(v || '').replace(/\D/g, '');
  }

  function formatCep(v) {
    var d = onlyDigits(v).slice(0, 8);
    if (d.length > 5) return d.slice(0, 5) + '-' + d.slice(5);
    return d;
  }

  function money(cents) {
    try {
      return (Number(cents) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return 'R$ ' + (Number(cents) / 100).toFixed(2);
    }
  }

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function bindShipping(scope) {
    var box = (scope || document).querySelector('[data-g3d-cart-shipping]');
    if (!box || box.dataset.g3dBound === '1') return;
    box.dataset.g3dBound = '1';

    var input = box.querySelector('[data-g3d-cart-cep]');
    var btn = box.querySelector('[data-g3d-cart-cep-btn]');
    var results = box.querySelector('[data-g3d-cart-cep-results]');
    if (!input || !btn || !results) return;

    input.addEventListener('input', function () {
      input.value = formatCep(input.value);
    });

    btn.addEventListener('click', function () {
      var cep = onlyDigits(input.value);
      if (cep.length !== 8) {
        results.hidden = false;
        results.innerHTML = '<p class="g3d-cart-drawer__shipping-error">Informe um CEP válido (8 dígitos).</p>';
        return;
      }

      btn.disabled = true;
      btn.textContent = '…';
      results.hidden = false;
      results.innerHTML = '<p class="g3d-cart-drawer__shipping-loading">Consultando frete…</p>';

      fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function (r) {
          return r.json();
        })
        .catch(function () {
          return {};
        })
        .then(function (addr) {
          var province = (addr && addr.uf) || '';
          var city = (addr && addr.localidade) || '';
          var street = (addr && addr.logradouro) || 'Rua';
          var url =
            rootPath() +
            'cart/shipping_rates.json?shipping_address%5Bzip%5D=' +
            encodeURIComponent(cep) +
            '&shipping_address%5Bcountry%5D=Brazil' +
            '&shipping_address%5Baddress1%5D=' +
            encodeURIComponent(street);
          if (province) {
            url += '&shipping_address%5Bprovince%5D=' + encodeURIComponent(province);
          }
          if (city) {
            url += '&shipping_address%5Bcity%5D=' + encodeURIComponent(city);
          }
          return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json().then(function (data) {
              return { ok: r.ok, data: data, city: city, uf: province };
            });
          });
        })
        .then(function (res) {
          var rates = (res.data && res.data.shipping_rates) || [];
          try {
            window.sessionStorage.setItem('g3d_cart_cep', cep);
          } catch (e) {}

          if (!res.ok || !rates.length) {
            results.innerHTML =
              '<p class="g3d-cart-drawer__shipping-error">Não foi possível calcular aqui. <a href="/cart#frete">Abrir calculadora completa</a>.</p>';
            return;
          }
          var meta =
            res.city && res.uf
              ? '<p class="g3d-cart-drawer__shipping-loading">' + res.city + '/' + res.uf + '</p>'
              : '';
          var html = meta + '<ul class="g3d-cart-drawer__shipping-list">';
          rates.slice(0, 4).forEach(function (rate) {
            var price =
              Number(rate.price) === 0
                ? 'Grátis'
                : money(Math.round(Number(rate.price) * 100));
            var name = rate.name || rate.delivery_name || 'Entrega';
            html +=
              '<li><span>' +
              name +
              '</span><strong>' +
              price +
              '</strong></li>';
          });
          html +=
            '</ul><p class="g3d-cart-drawer__shipping-note"><a href="/cart#frete">Ver todas as opções</a></p>';
          results.innerHTML = html;
        })
        .catch(function () {
          results.innerHTML =
            '<p class="g3d-cart-drawer__shipping-error">Falha ao consultar. <a href="/cart#frete">Abrir calculadora</a>.</p>';
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = 'Calcular';
        });
    });
  }

  function boot() {
    bindShipping(document);
    prefFillCartPageCep();
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer || drawer.dataset.g3dShipObserved) return;
    drawer.dataset.g3dShipObserved = '1';
    new MutationObserver(function () {
      window.clearTimeout(window.__g3dShipT);
      window.__g3dShipT = window.setTimeout(function () {
        bindShipping(document);
      }, 150);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function prefFillCartPageCep() {
    if (!/\/cart\/?$/.test(window.location.pathname) && window.location.hash !== '#frete') {
      if (window.location.hash !== '#frete') return;
    }
    var cep = '';
    try {
      cep = window.sessionStorage.getItem('g3d_cart_cep') || '';
    } catch (e) {}
    if (!cep || cep.length !== 8) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var input =
        document.querySelector('#frete input[type="text"]') ||
        document.querySelector('[id*="frete" i] input') ||
        document.querySelector('.shopify-app-block input[placeholder*="CEP" i]') ||
        document.querySelector('input[placeholder*="CEP" i]');
      if (input) {
        input.value = formatCep(cep);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        var btn =
          input.closest('form') && input.closest('form').querySelector('button') ||
          document.querySelector('.shopify-app-block button') ||
          document.querySelector('button[type="submit"]');
        if (btn && /calcul/i.test(btn.textContent || '')) {
          btn.click();
        }
        window.clearInterval(timer);
      }
      if (tries > 20) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

